'use strict'

import React from 'react';

import Layout from '../Layout.jsx';
import ProjectMenu from '../components/ProjectMenu.jsx';
import FormattedContent from '../components/FormattedContent.jsx';

import {Themes, ActivityView, Links, StatusSummary, KeyInfo} from '../ProjectDetails.jsx';
import Portfolio from '../Portfolio.jsx';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('../add/labels/english.js'),
    require('../add/labels/norwegian.js')
]);

function hasValue(value) {
  return value!==undefined && value!==null && value.trim().length>0;
}

class ProductDefinition extends React.Component {
  render() {
    let product=this.props.product;
    let labels=translations.getTranslation(this.props).product.fields;
    return hasValue(product.vision) || hasValue(product.description) || hasValue(product.background) ? (
      <div style={{paddingTop:20}}>
        <h2>{product.name}</h2>
        {hasValue(product.vision) ? (
          <div style={{fontStyle:"italic", paddingBottom:10}}>
            <FormattedContent value={product.vision}/>
          </div>
        ) : null}
        {hasValue(product.description) ? (
          <div>
            <FormattedContent value={product.description}/>
          </div>
        ) : null}
        {hasValue(product.background) ? (
          <div style={{paddingTop:10}}>
            <b>{labels.background.title}</b>
            <div>
              <FormattedContent value={product.background}/>
            </div>
          </div>
        ) : null}
      </div>
    ) : null;
  }
}

function assignPriority(item) {
  return item.status!=="Closed"
    ? Object.assign({},item,{row:parseInt(item.priority),column:parseInt(item.severity)})
    :  Object.assign({},item,{row:undefined,column:undefined});
}

export class ProductDetails extends React.Component {
  render() {
    let access={
      isBusinessCaseEnabled: ()=>false,//this.isBusinessCaseEnabled.bind(this),
      isQualityEnabled: ()=>false, //this.isQualityEnabled.bind(this),
      isDefinitionEnabled: ()=>true, //this.isDefinitionEnabled.bind(this),
      isProjectBriefEnabled: ()=>false,
      isPIDEnabled : ()=>false
    };


    var portfolio=this.props.portfolio!==undefined ? this.props.portfolio :
        this.props.product!==undefined && this.props.product.portfolio!==undefined && this.props.tenant.portfolios!==undefined ?
        this.props.tenant.portfolios.filter(portfolio=>portfolio.id===this.props.product.portfolio)[0] : undefined;

    return (
      <div style={{marginTop: 40, marginLeft:30, fontFamily:"Lato"}}>
        {this.props.product.isStopped ? <span style={{color:"red", paddingRight:20}}>STOPPED</span> :null}
        {this.props.product.isPaused ? <span style={{color:"red", paddingRight: 20}}>paused</span> :null}


        <div style={{display:"flex", flexWrap:"wrap", justifyContent:"flex-start"}}>
        <div style={{maxWidth:1016}}>
          <div style={{fontWeight:"bold", fontSize:14 }}>
            {portfolio!==undefined ? portfolio.name : null}
          </div>
          <div style={{fontSize:30, marginBottom:30, width:"100%", fontWeight:"bold", float:"left"}}>
            {this.props.product.name}
          </div>

          <div style={{display:"inline-block"}}>
            <div style={{padding:0, marginBottom:10, display:"flex", justifyContent: "space-between", flexWrap:"wrap"}}>
              <StatusSummary {...this.props.product}   {...this.props}/>
              <KeyInfo {...this.props.product}   {...this.props}/>
            </div>
            <div style={{display:"flex", flexWrap:"wrap", justifyContent:"flex-start"}}>

                <div style={{maxWidth:1016}}>
                  <Themes
                    {...this.props}
                    style="small"
                    project={this.props.product}
                    access={access}
                  />
                {this.props.releases!==undefined
                  && (this.props.releases.length>0
                    || this.props.historicReleases!==undefined
                      && this.props.historicReleases.length>0
                    ) ? (
                  <div style={{minWidth: 1016}}>
                    <Portfolio
                      {...this.props}
                      tenant={undefined}
                      design={this.props.tenant.design}
                      projects={this.props.releases}
                      historicProjects={this.props.historicReleases}
                      projectTypes={this.props.tenant.projectTypes}
                      disablePriority={true}
                    />
                  </div>
                  ) : (
                    <div style={{minWidth: 1016}}>
                    </div>
                  ) }
                <ProductDefinition {...this.props}/>
                </div>
              </div>
            </div>
          </div>
          <div style={{marginLeft:"auto"}}>
            <Links
              {...this.props}
              {...this.props.product}
              standardLinks={this.props.tenant.standardLinks}
              mode={this.props.linkMode}
              edit={this.props.edit}
              add={this.props.add}
              briefEnabled={false}
              pidEnabled={false}
            />
          </div>

        </div>
      </div>
    );
  }
}

export default class ProductDetailsPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true)
      ? <ProjectMenu
          {...this.props}
          project={this.props.product}
        />
      : undefined;
    return (
      <Layout {...this.props} project={this.props.product} projectMenu={menu}>
        <ProductDetails {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/product/ProductDetails.jsx